{
  "{account} needs to sign in again.": "{account} behöver logga in igen.",
  "{account} no longer has access to Johku Hub.": "{account} har inte längre tillgång till Johku Hub.",
  "{done} of {total}": "{done} av {total}",
  "{left} of {total} left": "{left} av {total} kvar",
  "{n} by email": "{n} via mejl",
  "{n} by push": "{n} som avisering",
  "{n} customer waiting for a reply": "{n} kund väntar på svar",
  "{n} customers waiting for a reply": "{n} kunder väntar på svar",
  "{n} let in on this phone": "{n} insläppta med den här telefonen",
  "{n} message": "{n} meddelande",
  "{n} message hasn't been sent yet and will be lost.": "{n} meddelande har inte skickats än och går förlorat.",
  "{n} messages": "{n} meddelanden",
  "{n} messages haven't been sent yet and will be lost.": "{n} meddelanden har inte skickats än och går förlorade.",
  "{n} more: search by name.": "{n} till: sök på namn.",
  "{n} of {total}": "{n} av {total}",
  "{n} pcs": "{n} st",
  "{n} shop chosen": "{n} butik vald",
  "{n} shops chosen": "{n} butiker valda",
  "{n} ticket": "{n} biljett",
  "{n} tickets": "{n} biljetter",
  "{n} unread": "{n} olästa",
  "{n} unread conversation": "{n} oläst konversation",
  "{n} unread conversations": "{n} olästa konversationer",
  "{n} use left": "{n} användning kvar",
  "{n} uses left": "{n} användningar kvar",
  "{name} ({n} member)": "{name} ({n} medlem)",
  "{name} ({n} members)": "{name} ({n} medlemmar)",
  "{name} and {n} more": "{name} och {n} till",
  "{name} sent you a message in Johku Hub ({subject}).": "{name} har skickat dig ett meddelande i Johku Hub ({subject}).",
  "{name} sent you a message in Johku Hub.": "{name} har skickat dig ett meddelande i Johku Hub.",
  "{shop} can sell its products in your sales channel. Once they accept, Johku puts it into effect.": "{shop} kan sälja sina produkter i din försäljningskanal. När de godkänner tar Johku det i bruk.",
  "{shop} sent you a message about your order {order}.": "{shop} har skickat dig ett meddelande om din beställning {order}.",
  "{shop} would like to talk with you. Reply or accept to continue.": "{shop} vill prata med er. Svara eller godkänn för att fortsätta.",
  "{sold} of {seats} sold": "{sold} av {seats} sålda",
  "{used} of {total} let in": "{used} av {total} insläppta",
  "A Bluetooth or USB scanner that types the code, as in the POS's ticket reader.": "En Bluetooth- eller USB-skanner som skriver in koden, som i kassans biljettläsare.",
  "About Johku": "Om Johku",
  "Accept": "Godkänn",
  "Accepted the offer: {channel}, {commission} % commission.": "Godkände erbjudandet: {channel}, {commission} % provision.",
  "Accepted, being put into effect in Johku": "Godkänt, tas i bruk i Johku",
  "Accepted, but Johku couldn't put it into effect: {error}": "Godkänt, men Johku kunde inte ta det i bruk: {error}",
  "Accepted, in effect in Johku": "Godkänt, i bruk i Johku",
  "Access and instructions": "Instruktioner för åtkomst och användning",
  "Accounts": "Konton",
  "Accounts and settings": "Konton och inställningar",
  "Add account": "Lägg till konto",
  "Add an account": "Lägg till ett konto",
  "All": "Alla",
  "All caught up": "Allt är läst",
  "All incidents": "Alla störningar",
  "All orders": "Alla beställningar",
  "All shops": "Alla butiker",
  "All your shops ({n})": "Alla dina butiker ({n})",
  "Allow": "Tillåt",
  "Allow {app} to use Johku Hub?": "Ge {app} åtkomst till Johku Hub?",
  "Already used": "Redan använd",
  "an assistant": "en assistent",
  "An assistant asks to use your Johku Hub conversations. Sign in first.": "En assistent ber om åtkomst till dina konversationer i Johku Hub. Logga in först.",
  "As {name}": "Som {name}",
  "Ask the shop": "Fråga butiken",
  "Attach a file": "Bifoga en fil",
  "Back": "Tillbaka",
  "Between organisations": "Mellan organisationer",
  "Booking": "Bokning",
  "Can't load the collections right now.": "Samlingarna kan inte laddas just nu.",
  "Can't load the list of organisations right now.": "Organisationerna kan inte hämtas just nu.",
  "Can't reach Johku Hub. Check your connection and try again.": "Johku Hub kan inte nås. Kontrollera anslutningen och försök igen.",
  "Cancel": "Avbryt",
  "Cancelled": "Avbokad",
  "Cause found, being fixed": "Orsaken hittad, åtgärdas",
  "Check in": "Checka in",
  "Check out": "Checka ut",
  "Check-in opens {time}.": "Incheckningen öppnar {time}.",
  "Checked in {time}": "Incheckad {time}",
  "Checked out {time}": "Utcheckad {time}",
  "Checking in…": "Checkar in…",
  "Checking out…": "Checkar ut…",
  "Checking the ticket…": "Kontrollerar biljetten…",
  "Choose a conversation": "Välj en konversation",
  "Choose resources and start times": "Välj resurser och starttider",
  "Choose the seats to let in": "Välj platserna som släpps in",
  "Choose the shows to scan for": "Välj föreställningarna att skanna för",
  "Chosen shops": "Valda butiker",
  "Close": "Stäng",
  "Code sent to {email}": "Koden skickades till {email}",
  "Codes": "Koder",
  "Commission (%)": "Provision (%)",
  "Confirmed": "Bekräftad",
  "Conversation": "Konversation",
  "Conversation with the shop": "Konversation med butiken",
  "Conversations with the Johku team and shops show up here.": "Konversationer med Johku och butiker visas här.",
  "Copied": "Kopierat",
  "Copy the code": "Kopiera koden",
  "customer": "kund",
  "Customer": "Kund",
  "Decline": "Avböj",
  "Declined": "Avböjt",
  "Declined the offer.": "Avböjde erbjudandet.",
  "Deny": "Neka",
  "Done": "Klar",
  "Download": "Ladda ner",
  "Downloading {name}": "Laddar ned {name}",
  "E.g. Card payments fail": "T.ex. Kortbetalningar fungerar inte",
  "Each member gets it in a conversation of their own with the shop, and their replies come to you one by one.": "Varje medlem får det i en egen konversation med butiken, och deras svar kommer till dig ett i taget.",
  "Email address": "E-postadress",
  "Email those who don't have the app": "Mejla dem som inte har appen",
  "Event times, cancellations and the shop's replies.": "Tider för evenemang, avbokningar och butikens svar.",
  "Every shop": "Alla butiker",
  "Everything you've bought from Johku shops, in one place.": "Allt du har köpt i Johku-butiker, på ett ställe.",
  "Expired {date}": "Gick ut {date}",
  "Find a shop": "Sök butik",
  "Fixed, monitoring": "Åtgärdat, följs upp",
  "For": "Till",
  "For every shop": "Till alla butiker",
  "For: {shops}": "Till: {shops}",
  "Get started": "Kom igång",
  "Get told about new messages": "Få en avisering om nya meddelanden",
  "Getting the shows…": "Hämtar föreställningarna…",
  "Getting the tickets…": "Hämtar biljetterna…",
  "Gift cards and other codes you buy from Johku shops show up here.": "Presentkort och andra koder du köper i Johku-butiker visas här.",
  "Hide": "Dölj",
  "Hide used and expired codes": "Dölj använda och utgångna koder",
  "Home": "Hem",
  "Hub may not use the camera. Allow it in the phone's settings.": "Hub får inte använda kameran. Tillåt det i telefonens inställningar.",
  "In messages": "I meddelanden",
  "Incidents": "Störningar",
  "Incidents in Johku": "Störningar i Johku",
  "Investigating": "Utreds",
  "It is valid for 10 minutes. If you didn't ask for it, you can ignore this email.": "Den gäller i 10 minuter. Om du inte bad om den kan du strunta i det här mejlet.",
  "It opens signed in, and stays open in the background": "Den öppnas inloggad och hålls öppen i bakgrunden",
  "It sees only what you see in Johku Hub, and every use is logged.": "Den ser bara det du ser i Johku Hub, och varje användning loggas.",
  "Johku account": "Johku-konto",
  "Johku agreement": "Johku-avtal",
  "Johku App": "Johku App",
  "Johku Hub isn't working right now. Try again in a moment.": "Johku Hub fungerar inte just nu. Försök igen om en stund.",
  "Johku Hub sign-in code: {code}": "Inloggningskod för Johku Hub: {code}",
  "Johku status: {title}": "Johku-status: {title}",
  "Kind of conversation": "Typ av konversation",
  "Know when things change": "Vet när något ändras",
  "Language": "Språk",
  "Let in {n}": "Släpp in ({n})",
  "Let in: {n} seat": "Insläppt: {n} plats",
  "Let in: {n} seats": "Insläppta: {n} platser",
  "Light off": "Släck lampan",
  "Light on": "Tänd lampan",
  "Loading…": "Laddar…",
  "Main menu": "Huvudmeny",
  "Maintenance": "Underhåll",
  "Make an offer": "Lämna ett erbjudande",
  "Members of": "Medlemmar i",
  "Members' replies come as conversations of their own.": "Medlemmarnas svar kommer som egna konversationer.",
  "Message": "Meddelande",
  "Message (optional)": "Meddelande (valfritt)",
  "Message the seller about your order and get told when they reply.": "Skriv till säljaren om din beställning och få en avisering när de svarar.",
  "Message to {shop}": "Meddelande till {shop}",
  "Message to the shops": "Meddelande till butikerna",
  "Messages": "Meddelanden",
  "Messages can't be reached right now.": "Meddelandena kan inte nås just nu.",
  "My Johku": "My Johku",
  "Name, sign-in and deleting the account": "Namn, inloggning och borttagning av kontot",
  "New conversation": "Ny konversation",
  "New incident": "Ny störning",
  "New message from {name} in Johku Hub": "Nytt meddelande från {name} i Johku Hub",
  "New message from {shop}": "Nytt meddelande från {shop}",
  "New message: {shop}, order {order}": "Nytt meddelande: {shop}, beställning {order}",
  "New messages in Johku Hub": "Nya meddelanden i Johku Hub",
  "Next up": "Härnäst",
  "No connection. Check the connection and try again.": "Ingen anslutning. Kontrollera anslutningen och försök igen.",
  "No conversations yet": "Inga konversationer än",
  "No conversations yet. Start one with the pen above.": "Inga konversationer än. Starta en med pennan ovan.",
  "No email? It can take a minute. Check the spam folder too.": "Inget e-postmeddelande? Det kan dröja en stund. Titta också i skräpposten.",
  "No incidents in the last 30 days.": "Inga störningar de senaste 30 dagarna.",
  "No matches.": "Inga träffar.",
  "No messages about this order yet. The customer gets an email with a link to the order page, where they can read and reply.": "Inga meddelanden om den här beställningen än. Kunden får ett e-postmeddelande med en länk till beställningssidan, där hen kan läsa och svara.",
  "No messages yet": "Inga meddelanden än",
  "No messages yet.": "Inga meddelanden än.",
  "No shows match.": "Inga föreställningar matchar.",
  "No tickets start today for these.": "Inga biljetter börjar i dag för dessa.",
  "No valid codes": "Inga giltiga koder",
  "None of the shop's collections has members yet.": "Ingen av butikens samlingar har medlemmar ännu.",
  "Not a valid ticket": "Ingen giltig biljett",
  "Not sent: {error}": "Inte skickat: {error}",
  "Not shown yet": "Visas inte än",
  "Not working": "Fungerar inte",
  "Nothing matches “{query}”.": "Inget matchar ”{query}”.",
  "Nothing to scan from today on.": "Inget att skanna från i dag och framåt.",
  "Notice": "Meddelande",
  "Notifications are blocked for this site in the browser's settings.": "Aviseringar är blockerade för den här webbplatsen i webbläsarens inställningar.",
  "Notifications are off for Johku Hub in the phone's settings.": "Aviseringar för Johku Hub är avstängda i telefonens inställningar.",
  "Notifications of new messages: {name}": "Aviseringar om nya meddelanden: {name}",
  "Now": "Nu",
  "Offer a sales channel": "Erbjud en försäljningskanal",
  "Offer: sell your products in {channel} with a {commission} % commission.": "Erbjudande: sälj era produkter i {channel} med {commission} % provision.",
  "Offline": "Offline",
  "Offline. {n} message will send when the connection returns.": "Offline. {n} meddelande skickas när anslutningen är tillbaka.",
  "Offline. {n} messages will send when the connection returns.": "Offline. {n} meddelanden skickas när anslutningen är tillbaka.",
  "Offline. Messages will send when the connection returns.": "Offline. Meddelandena skickas när anslutningen är tillbaka.",
  "Offline. These are the codes saved on this phone ({time}).": "Offline. Det här är koderna som sparats på telefonen ({time}).",
  "Offline. These are the orders saved on this phone.": "Offline. Det här är beställningarna som sparats på telefonen.",
  "Offline. These are the tickets saved on this phone ({time}).": "Offline. Det här är biljetterna som sparats på telefonen ({time}).",
  "OK": "OK",
  "One use": "En användning",
  "Only for {name}: check their ID.": "Endast för {name}: kontrollera legitimationen.",
  "Only the shop's users who can use the POS can scan its tickets.": "Endast butikens användare med tillgång till kassan kan skanna dess biljetter.",
  "Only your own sign-in: your shop and its Johku agreement are managed in Johku App.": "Endast din egen inloggning: din butik och dess Johku-avtal hanteras i Johku App.",
  "Open Johku App": "Öppna Johku App",
  "Open the order": "Öppna beställningen",
  "Open the order in the shop": "Öppna beställningen i butiken",
  "Opening…": "Öppnar…",
  "Opens in a new tab": "Öppnas i en ny flik",
  "Order": "Beställning",
  "Order {id}": "Beställning {id}",
  "Orders": "Beställningar",
  "Other merchants": "Andra handlare",
  "Other merchants find {shop}": "Andra handlare hittar {shop}",
  "Other orders": "Andra beställningar",
  "Paid": "Betalat",
  "Partly working": "Fungerar delvis",
  "Pictures, PDF, text, Word and Excel files only": "Endast bilder, PDF-, text-, Word- och Excel-filer",
  "PIN code": "PIN-kod",
  "PIN codes": "PIN-koder",
  "Point the camera at a ticket's code.": "Rikta kameran mot biljettens kod.",
  "Privacy policy": "Integritetspolicy",
  "Private message": "Privat meddelande",
  "Questions about your order? The shop's answer comes to Messages.": "Frågor om din beställning? Butikens svar kommer till Meddelanden.",
  "Read and reply: {url}": "Läs och svara: {url}",
  "Read and search your conversations": "Läsa och söka i dina konversationer",
  "Reader settings": "Läsarens inställningar",
  "Ready for the next ticket.": "Redo för nästa biljett.",
  "Recent": "Senaste",
  "Recipient": "Mottagare",
  "Refunded": "Återbetalad",
  "Reload": "Ladda om",
  "Remove": "Ta bort",
  "Reply in the Johku app or at {url}, signed in with this email address.": "Svara i Johku-appen eller på {url}, inloggad med den här e-postadressen.",
  "Resolved": "Löst",
  "Resolved: {title}": "Löst: {title}",
  "Resources": "Resurser",
  "Row {row}, seat {seat}": "Rad {row}, plats {seat}",
  "Row {row}, seats {seats}": "Rad {row}, platser {seats}",
  "Sales channel offer": "Erbjudande om försäljningskanal",
  "Save": "Spara",
  "Saved in Downloads": "Sparad i Nedladdningar",
  "Saving files needs Android 10 or newer": "Att spara filer kräver Android 10 eller senare",
  "Scan a ticket with your scanner.": "Skanna en biljett med din skanner.",
  "Scan for {n} show": "Skanna för {n} föreställning",
  "Scan for {n} shows": "Skanna för {n} föreställningar",
  "Scan for {n} start time": "Skanna för {n} starttid",
  "Scan for {n} start times": "Skanna för {n} starttider",
  "Scan tickets": "Skanna biljetter",
  "Search": "Sök",
  "Search by name": "Sök efter namn",
  "Search conversations": "Sök i konversationer",
  "Search shows": "Sök föreställningar",
  "Seat": "Plats",
  "Seat {seat}": "Plats {seat}",
  "Seats {seats}": "Platser {seats}",
  "See all": "Visa alla",
  "Sell, check tickets and answer customers in Johku App.": "Sälj, kontrollera biljetter och svara kunder i Johku App.",
  "Send": "Skicka",
  "Send as": "Avsändare",
  "Send code": "Skicka kod",
  "Send messages and start conversations as you": "Skicka meddelanden och starta konversationer i ditt namn",
  "Send now": "Skicka nu",
  "Send the offer": "Skicka erbjudandet",
  "Send to members": "Skicka till medlemmar",
  "Send to shops": "Skicka till butikerna",
  "Send update": "Skicka uppdatering",
  "Sending…": "Skickar…",
  "Sent to {done} of {n} people": "Skickat till {done} av {n} personer",
  "Sent to {done} of {n} person": "Skickat till {done} av {n} person",
  "Severity": "Allvarlighetsgrad",
  "Shop": "Butik",
  "Show booking": "Visa bokningen",
  "Show conversations of": "Visa konversationer för",
  "Show more": "Visa mer",
  "Show orders of": "Visa beställningar från",
  "Show the code at the door.": "Visa koden vid dörren.",
  "Show the code at the till, or type it in the shop's online store.": "Visa koden i kassan eller skriv in den i butikens webbutik.",
  "Show tickets": "Visa biljetter",
  "Show used and expired codes": "Visa använda och utgångna koder",
  "Shows": "Föreställningar",
  "Sign in": "Logga in",
  "Sign in again": "Logga in igen",
  "Sign in to Johku Hub": "Logga in på Johku Hub",
  "Sign in with an email code": "Logga in med en e-postkod",
  "Sign in with Johku": "Logga in med Johku",
  "Sign out": "Logga ut",
  "Sign out of {email}? Its messages are removed from this device.": "Logga ut från {email}? Kontots meddelanden tas bort från den här enheten.",
  "Sign out of this account": "Logga ut från det här kontot",
  "Sign out?": "Logga ut?",
  "Signing in with Johku didn't finish. Please try again.": "Inloggningen med Johku slutfördes inte. Försök igen.",
  "Signing in with Johku didn't work ({error}).": "Inloggningen med Johku lyckades inte ({error}).",
  "Signing in…": "Loggar in…",
  "So you see customers' questions right away": "Så ser du kundernas frågor direkt",
  "Some shops didn't answer, so their codes may be missing: {shops}": "Några butiker svarade inte, så deras koder kan saknas: {shops}",
  "Someone": "Någon",
  "Something went wrong.": "Något gick fel.",
  "Something went wrong. Please try again.": "Något gick fel. Försök igen.",
  "Something went wrong. Try again in a moment.": "Något gick fel. Försök igen om en stund.",
  "Sounds": "Ljud",
  "Start the conversation": "Starta konversationen",
  "Start times today": "Starttider i dag",
  "Status": "Status",
  "Subject (optional)": "Ämne (valfritt)",
  "Support": "Support",
  "Swipe for the next one": "Svep till nästa",
  "Switch camera": "Byt kamera",
  "Switch shop": "Byt butik",
  "That code has expired. Ask for a new one.": "Koden har gått ut. Be om en ny.",
  "That code isn't right. Check it and try again.": "Koden stämmer inte. Kontrollera den och försök igen.",
  "That didn't go through. Try again in a moment.": "Det gick inte. Försök igen om en stund.",
  "The booking isn't confirmed.": "Bokningen är inte bekräftad.",
  "The camera didn't start.": "Kameran startade inte.",
  "The code is on its way. Check again in a moment.": "Koden är på väg. Titta igen om en stund.",
  "The conversation was declined.": "Konversationen avböjdes.",
  "The device's language": "Enhetens språk",
  "The download failed": "Nedladdningen misslyckades",
  "The file is larger than 20 MB": "Filen är större än 20 MB",
  "The Johku team": "Johku-teamet",
  "The Johku team keeps you posted here until it's resolved.": "Johku-teamet håller dig uppdaterad här tills det är löst.",
  "The order page can't be opened right now. Try again in a moment.": "Beställningens sida kan inte öppnas just nu. Försök igen om en stund.",
  "The PIN code and instructions show from {time}.": "PIN-koden och instruktionerna visas från {time}.",
  "The shop can't be reached about this order from here. Try its order page.": "Butiken kan inte nås om den här beställningen härifrån. Försök via beställningens sida.",
  "The ticket couldn't be confirmed. Scan it again.": "Biljetten kunde inte bekräftas. Skanna den igen.",
  "The ticket is for {what}.": "Biljetten gäller {what}.",
  "The ticket is for another place.": "Biljetten gäller en annan lokal.",
  "The ticket is for another shop.": "Biljetten tillhör en annan butik.",
  "The ticket is for another show.": "Biljetten gäller en annan föreställning.",
  "The ticket is for another time.": "Biljetten gäller en annan tid.",
  "The tickets can't be opened right now. Try again in a moment.": "Biljetterna kan inte öppnas just nu. Försök igen om en stund.",
  "There's no one {name} can write to yet.": "Det finns ännu ingen som {name} kan skriva till.",
  "These tickets aren't available any more.": "De här biljetterna är inte längre tillgängliga.",
  "this account": "det här kontot",
  "This browser can't read codes with the camera. Use the Johku Hub app, or a scanner (settings).": "Den här webbläsaren kan inte läsa koder med kameran. Använd appen Johku Hub eller en skanner (inställningar).",
  "This device has no camera.": "Den här enheten har ingen kamera.",
  "This goes now to the staff of {n} shop, by push and email. Send it?": "Det här skickas nu till personalen i {n} butik, som avisering och mejl. Skicka?",
  "This goes now to the staff of {n} shops, by push and email. Send it?": "Det här skickas nu till personalen i {n} butiker, som avisering och mejl. Skicka?",
  "This goes now to the staff of every shop, by push and email. Send it?": "Det här skickas nu till personalen i alla butiker, som avisering och mejl. Skicka?",
  "This incident isn't shown any more.": "Den här störningen visas inte längre.",
  "This order has been cancelled. Its tickets aren't valid.": "Beställningen har avbokats. Dess biljetter är inte giltiga.",
  "This order has been refunded. Its tickets aren't valid.": "Beställningen har återbetalats. Dess biljetter är inte giltiga.",
  "Ticket": "Biljett",
  "Ticket {n} of {total}": "Biljett {n} av {total}",
  "Tickets": "Biljetter",
  "Tickets at hand": "Biljetterna nära till hands",
  "To (email)": "Till (e-post)",
  "To members": "Till medlemmar",
  "To the members of {collection}: {n} member": "Till medlemmarna i {collection}: {n} medlem",
  "To the members of {collection}: {n} members": "Till medlemmarna i {collection}: {n} medlemmar",
  "To the members of {collection}: sending, {sent}/{n}": "Till medlemmarna i {collection}: skickas, {sent}/{n}",
  "Today": "Idag",
  "Tomorrow": "I morgon",
  "Total": "Totalt",
  "Try again": "Försök igen",
  "Turn on notifications": "Slå på aviseringar",
  "Unpaid": "Obetalat",
  "Upcoming": "Kommande",
  "Update to the shops": "Uppdatering till butikerna",
  "Use a scanner instead of the camera": "Använd en skanner i stället för kameran",
  "Use another address": "Använd en annan adress",
  "Used": "Använd",
  "Uses": "Användningar",
  "Valid from {date}": "Giltig från {date}",
  "Valid until {date}": "Giltig till {date}",
  "Validity": "Giltighet",
  "Value left": "Återstående värde",
  "Venue": "Plats",
  "Vibration": "Vibration",
  "Waiting for {shop} to accept the conversation.": "Väntar på att {shop} godkänner konversationen.",
  "Waiting for an answer": "Väntar på svar",
  "We'll email you a sign-in code. Use the address you use with Johku.": "Vi skickar en inloggningskod till din e-post. Använd adressen du använder hos Johku.",
  "What doesn't work, who it concerns, what to do meanwhile.": "Vad som inte fungerar, vem det gäller och vad man kan göra under tiden.",
  "What you offer, and what kind of partners you look for": "Vad ni erbjuder och vilka partner ni söker",
  "What's wrong": "Vad är fel",
  "When": "När",
  "When something in Johku doesn't work, and when it's fixed": "När något i Johku inte fungerar, och när det är åtgärdat",
  "When you buy from a Johku shop with {email}, the order appears here on its own.": "När du handlar i en Johku-butik med {email} visas beställningen här automatiskt.",
  "When you buy from a Johku shop with your email, the order appears here on its own.": "När du handlar i en Johku-butik med din e-postadress visas beställningen här av sig själv.",
  "Whether other Johku merchants find your shop and can invite it to a conversation": "Om andra Johku-handlare hittar din butik och kan bjuda in den till en konversation",
  "With the customer": "Med kunden",
  "With your email, Google or Microsoft, as in Johku's online shops.": "Med din e-post, Google eller Microsoft, som i Johkus webbutiker.",
  "Withdraw the offer": "Dra tillbaka erbjudandet",
  "Withdrawn": "Tillbakadraget",
  "Withdrew the offer.": "Drog tillbaka erbjudandet.",
  "Write a message": "Skriv ett meddelande",
  "Write to the customer": "Skriv till kunden",
  "Write to the shop": "Skriv till butiken",
  "Yesterday": "Igår",
  "You": "Du",
  "You can close this page.": "Du kan stänga den här sidan.",
  "You get this because you work for a shop on Johku. Follow the situation in the Johku app or at {url}.": "Du får det här eftersom du arbetar i en butik som använder Johku. Följ läget i Johku-appen eller på {url}.",
  "You: ": "Du: ",
  "You'll see replies without opening the app.": "Du ser svaren utan att öppna appen.",
  "You're offline. A new conversation needs a connection.": "Du är offline. En ny konversation kräver en anslutning.",
  "You're offline. Checking in and out needs a connection.": "Du är offline. In- och utcheckning kräver en anslutning.",
  "You're offline. The first message needs a connection.": "Du är offline. Det första meddelandet kräver en anslutning.",
  "You're offline. Try again when the connection returns.": "Ingen anslutning. Försök igen när anslutningen är tillbaka.",
  "You're staff at {shop}": "Du arbetar på {shop}",
  "Your codes can't be loaded right now. Try again in a moment.": "Koderna kan inte laddas just nu. Försök igen om en stund.",
  "Your conversations with shops about your orders show up here.": "Dina konversationer med butiker om dina beställningar visas här.",
  "Your Johku account doesn't have access to Johku Hub yet.": "Ditt Johku-konto har inte tillgång till Johku Hub än.",
  "Your Johku Hub sign-in code is {code}.": "Din inloggningskod för Johku Hub är {code}.",
  "Your orders": "Dina beställningar",
  "Your orders can't be loaded right now. Try again in a moment.": "Beställningarna kan inte laddas just nu. Försök igen om en stund.",
  "Your other accounts stay signed in.": "Dina andra konton förblir inloggade.",
  "Your other accounts stay signed in. Switch between them from your picture on Home.": "Dina andra konton förblir inloggade. Byt mellan dem via din bild på Hem.",
  "Your session for {account} has ended. Please sign in again.": "Sessionen för {account} har tagit slut. Logga in igen.",
  "Your shop": "Din butik",
  "Your shop has no sales channel in Johku. Set one up in the Johku app's settings first.": "Din butik har ingen försäljningskanal i Johku. Skapa en först i inställningarna i Johku-appen.",
  "Your shops": "Dina butiker",
  "Your tickets will show up here": "Dina biljetter visas här",
  "Your tickets, orders and messages with shops": "Dina biljetter, beställningar och meddelanden med butiker"
}
